// extracted by mini-css-extract-plugin
module.exports = {"pagination":"pagination_pagination__152L8","item":"pagination_item__1GD76","active":"pagination_active__3er2a","hide":"pagination_hide__2nay8","link":"pagination_link__3BfrZ"};